import React from "react";
import { useHistory } from "react-router-dom";

function AddDinerNewRedirect(props) {
  const history = useHistory();
  const onOpenModal = (e) => {
    history.push("/seatingdashboard/adddiner");
  };
  return (
    <button
      type="button"
      className="btn btn-danger text-normal btn-xs rounded"
      onClick={onOpenModal}
    >
      + Add Diner
    </button>
  );
}

export default AddDinerNewRedirect;
